define('plugin/contact-widget/model/ContactWidgetModel',['require','lib/model/BaseModel','lib/validator/ValidatorEmail','lib/validator/ValidatorPhone','lib/validator/ValidatorNotEmpty'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var ValidatorEmail = require('lib/validator/ValidatorEmail');
	var ValidatorPhone = require('lib/validator/ValidatorPhone');
	var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');

    return BaseModel.extend({

        url: '/ext/contact-widget',

        defaults: {
            'name': '',
            'email': '',
            'phone': '',
            'message': ''
        },

        initialize: function() {
            BaseModel.prototype.initialize.call(this);

            this.validators = {
                'name': [new ValidatorNotEmpty()],
                'email': [new ValidatorNotEmpty(), new ValidatorEmail()],
                'phone': [new ValidatorPhone()],
                'message': [new ValidatorNotEmpty()]
            };
        }

    });

});

